
import axios from "../../axios";

export function summons__get_statictics() {
    return (async (dispatch) => {
        try {
            let response = await axios.get(`Summons/statistics`);
            dispatch({
                type: "SUMMONS_STATISTICS_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "SUMMONS_STATISTICS_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            });
        }
    })
}
export function summons__getById(summon_id) {
    return (async (dispatch) => {
        try {
            dispatch({ type: "SUMMONS_GET_BYID_CLEAR" });

            let response = await axios.get(`Summons/${summon_id}?filter=${encodeURIComponent(JSON.stringify({
                include: [
                    {
                        relation: "issuer",
                        scope: {
                            include: "patrollers"
                        }
                    },
                    {
                        relation: "summoner",
                        scope: {
                            fields: ["staffId", "name", "phoneNumber", "email", "id"]
                        }
                    },
                    {
                        relation: "offender"
                    },
                    {
                        relation: "vehicle"
                    },
                    {
                        relation: "infarctions"
                    },
                    {
                        relation: "pictures"
                    },
                    {
                        relation: "transactions",
                        scope: {
                            include: {
                                relation: "summoner",
                                scope: {
                                    fields: ["staffId", "name", "phoneNumber", "email", "id"]
                                }
                            },
                            order: "timestamp DESC"
                        }
                    }
                ]
            }))}`);

            if (!response.data) {
                dispatch({
                    type: "SUMMONS_GET_BYID_REJECTED",
                    payload: { error: "Removed", loaded: true, data: null }
                });
            } else {
                dispatch({
                    type: "SUMMONS_GET_BYID_FULFILLED",
                    payload: {
                        data: response.data,
                        loaded: true,
                        error: null
                    }
                });
            }
        }
        catch (e) {
            dispatch({
                type: "SUMMONS_GET_BYID_REJECTED",
                payload: {
                    loaded: true,
                    data: null,
                    error: e
                }
            });
        }
    })
}
export function summons__detailFineCommit(summon_id, val) {
    return (dispatch => {
        dispatch({
            type: "SUMMONS_DETAIL_MODIFY_FINE",
            payload: { id: summon_id, val: val }
        });
    })
}
export function summons__clrDetail() {
    return (async (dispatch) => {
        dispatch({ type: "SUMMONS_GET_BYID_CLEAR" });
    })
}
export function summons_approve(summonId, fine, reason, onApproveErr) {
    let attr = {}
    attr['fine'] = fine
    if (reason !== null || reason !== '') {
        attr['remark'] = reason
    }

    return (async (dispatch) => {
        try {
            let response = await axios.patch(`Summons/${summonId}/approve`, attr);
            dispatch({
                type: "SUMMONS_CREATE_APPROVED_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            })
            onApproveErr(null)
        }
        catch (e) {
            if (e.response) {
                onApproveErr(e.response.data.error)
                dispatch({
                    type: "SUMMONS_CREATE_APPROVED_REJECTED",
                    payload: {
                        data: null,
                        error: e.response.data.error
                    }
                });
            }
        }

    })
}
export function summon_approveSuccessful(summon) {
    return (dispatch => {
        dispatch({
            type: "SUMMONS_ISSUED_REMOVE_BYID",
            payload: summon.ref
        });
        dispatch(summons__get_statictics());
        //dispatch(summons__get_issued(0, 10))
        dispatch(summons__get_approved(0, 10))
    })
}
export function summon_archive(summonId, reason, onArchiveErr) {
    return (async (dispatch) => {
        try {
            let response = await axios.patch(`Summons/${summonId}/reject`, { remark: reason });
            dispatch({
                type: "SUMMONS_CREATE_ARCHIVED_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
            onArchiveErr(null);
        }
        catch (e) {
            onArchiveErr(e.response.data.error)
            dispatch({
                type: "SUMMONS_CREATE_ARCHIVED_REJECTED",
                payload: {
                    data: null,
                    error: encodeURIComponent.response.data.error
                }
            })
        }
    })
}
export function summon_archiveSuccessful(summon) {
    return (dispatch => {
        dispatch({
            type: "SUMMONS_ISSUED_REMOVE_BYID",
            payload: summon.ref
        });
        dispatch(summons__get_statictics());
        //dispatch(summons__get_issued(0, 10))
        dispatch(summons__get_approved(0, 10))
        dispatch(summons__get_archived(0, 10))
    });
}

export function summons_issued_typeahead(cb) {
    return (async (dispatch) => {
        try {
            let response = await axios.get(`Summons/pending/typeahead`);
            //console.log("summons__get_issued > response : \n", response);
            dispatch(
                {
                    type: "SUMMONS_ISSSUED_TYPEAHEAD_FULFILLED",
                    payload: {
                        data: response.data,
                        error: null
                    }
                }
            );
        }
        catch (e) {
            dispatch({
                type: "SUMMONS_ISSSUED_TYPEAHEAD_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            }
            );
        }
    });
}
export function summon_get_typeahead_summon() {

    return (async (dispatch) => {
        try {
            let response = await axios.get(`Summons/approved/typeahead`);
            //console.log("summons__get_issued > response : \n", response);
            dispatch(
                {
                    type: "SUMMONS_APPROVED_TYPEAHEAD_FULFILLED",
                    payload: {
                        data: response.data,
                        error: null
                    }
                }
            );
        }
        catch (e) {
            dispatch({
                type: "SUMMONS_APPROVED_TYPEAHEAD_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            }
            );
        }
    });

}





export function summons__get_issued(skip, limit) {
    return (async (dispatch) => {
        try {
            let response = await axios.get(`Summons/pending?offset=${skip}&limit=${limit}`);
            //console.log("summons__get_issued > response : \n", response);
            dispatch({
                type: "SUMMONS_ISSUED_GET_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "SUMMONS_ISSUED_GET_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            });
        }
    });
}
export function summons_get_issued_filtered(skip, limit, filter) {
    return (async (dispatch) => {
        try {
            dispatch({
                type: "SUMMONS_ISSUED_GET_PENDING",
                payload: {
                    data: filter,
                    error: null
                }
            });
            let response = await axios.get(`Summons/pending/filtered?skip=${skip}&limit=${limit}&filter=${encodeURIComponent(JSON.stringify(filter))}`);
            dispatch({
                type: "SUMMONS_ISSUED_GET_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "SUMMONS_ISSUED_GET_REJECTED",
                payload: {
                    response: null,
                    error: e
                }
            });
        }
    });
}
export function summons_issued_onItemsPerPage(count) {
    return (dispatch => {
        dispatch({
            type: "SUMMONS_ISSUED_ITEMPERPAGE",
            payload: {
                count
            }
        });
    });
}
export function summons_issued_onCurrentPageChanged(page) {
    return (dispatch => {
        dispatch({
            type: "SUMMONS_ISSUED_CURRENTPAGE",
            payload: {
                page
            }
        });
    })
}
export function summons_issued_onClear() {
    return (dispatch => {
        dispatch({
            type: "SUMMONS_ISSUED_CLEAR",
            payload: null
        });
    });
}

export function summons_approved_onItemsPerPage(count) {
    return (dispatch => { dispatch({ type: "SUMMONS_APPROVED_ITEMPERPAGE", payload: count }) })
}
export function summons_approved_onCurrentPageChanged(page) {
    return (dispatch => { dispatch({ type: "SUMMONS_APPROVED_CURRPAGE", payload: page }) })
}
export function summons__get_approved(skip, limit) {
    return (async (dispatch) => {
        try {
            let response = await axios.get(`Summons/approved?offset=${skip}&limit=${limit}`);
            dispatch({
                type: "SUMMONS_APPROVED_GET_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "SUMMONS_APPROVED_GET_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            });
        }
    });
}
export function summons_get_approved_filtered(skip, limit, filter) {
    return (async (dispatch) => {
        try {
            dispatch({
                type: "SUMMONS_APPROVED_GET_PENDING",
                payload: {
                    data: filter,
                    error: null
                }
            })
            let response = await axios.get(`Summons/approved/filtered?skip=${skip}&limit=${limit}&filter=${encodeURIComponent(JSON.stringify(filter))}`);
            dispatch({
                type: "SUMMONS_APPROVED_GET_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "SUMMONS_APPROVED_GET_REJECTED",
                payload: {
                    response: null,
                    error: e
                }
            });
        }
    });
}
export function summons_clr_approved() {
    return (dispatch => {
        dispatch({
            type: "SUMMONS_APPROVED_CLEAR",
            payload: null
        });
    })
}

export function summons_archived_onItemsPerPage(count) {
    return (dispatch => { dispatch({ type: "SUMMONS_ARCHIVED_ITEMPERPAGE", payload: count }) })
}
export function summons_archived_onCurrentPageChanged(page) {
    return (dispatch => { dispatch({ type: "SUMMONS_ARCHIVED_CURRPAGE", payload: page }) })
}
export function summons__get_archived(skip, limit) {
    return (async (dispatch) => {
        try {
            let response = await axios.get(`Summons/archived?offset=${skip}&limit=${limit}`);
            dispatch({
                type: "SUMMONS_ARCHIVED_GET_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "SUMMONS_ARCHIVED_GET_REJECTED",
                payload: {
                    data: null,
                    error: e
                }
            });
        }
    })
}
export function summons_clr_archived() {
    return (dispatch => {
        dispatch({
            type: "SUMMONS_ARCHIVED_CLEAR",
            payload: null
        });
    })
}
export function summons__get_archived_filtered(skip, limit, filter) {
    return (async (dispatch) => {
        try {
            dispatch({
                type: "SUMMONS_ARCHIVED_GET_PENDING",
                payload: {
                    data: filter,
                    error: null
                }
            })
            let response = await axios.get(`Summons/archived/filtered?skip=${skip}&limit=${limit}&filter=${encodeURIComponent(JSON.stringify(filter))}`);
            dispatch({
                type: "SUMMONS_ARCHIVED_GET_FULFILLED",
                payload: {
                    data: response.data,
                    error: null
                }
            });
        }
        catch (e) {
            dispatch({
                type: "SUMMONS_ARCHIVED_GET_REJECTED",
                payload: {
                    response: null,
                    error: e
                }
            });
        }
    });
}




// WEBPACK FOOTER //
// ./src/redux/actions/summons.js